export default "__VITE_ASSET__a0d81281__"